<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Slider"
            bc1="App"
            bc2="Slider"
            bc3="List"
            path="slider"
          ></Breadcrumb>
        </div>

      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push({ name: 'slider-add' })"
                  >
                    <AddButtonText name="Slider" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
            :url="url"
            :tableHeaderValues="tableHeaderValues"
            :actions="actions"
            :deleteActions="deleteActions"
            :mutedData="mutedData"
            :storageKey="storageKey"
            :externalTotalRecord="externalTotalRecord"
            :show-per-page="true"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>


import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  components: {AddButtonText},
  created() {
    this.url = "v1/get-slider";
  },
  mounted() {
    localStorage.setItem("url", "v1/get-slider");
    this.checkDataInStore('v1/get-slider')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      url: "v1/get-slider",
      storageKey: "slider",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: (value, row) => {
            var html = "";
            var sliderType = 'N/A'
            if(value == 1){
              sliderType = 'Mobile App'
            }else if(value == 2){
              sliderType = 'Android App'
            }
            else if(value == 3){
              sliderType = 'Ios App'
            }
            else if(value == 4){
              sliderType = 'Web App'
            }
            else if(value == 5){
              sliderType = 'Web Merchant'
            }else{
              sliderType = 'All'
            }

            html = `<span class="badge badge-light-primary badge-sm">${sliderType}</span>`
            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }
            return html;
          }
        },
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "sliderUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "slider-update" });
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "sliderDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    async checkData() {},
    deleteRecord(data) {
      this.makeRequest("post", "v1/update-slider-status", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("slider");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "slider";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>

